import React from 'react'
import MediaSlider from '../MediaSlider'

interface IProps {}

interface ICardProps {
    item: any
    classItem?: string
}

export const B2BMedia: React.FC<IProps> = () => {
    return (
        <>
            {/* <MediaSlider /> */}
        </>
    )
}
